import { getChainConstant } from '@/domain/chain';
import { SubgraphUrl } from '@/domain/subgraph';
import useChainId from '@/hooks/useChainId';
import querySubgraph from '@/infrastructure/subgraph';
import { useQuery } from '@tanstack/react-query';

const useAverageLockTime = () => {
  const chainId = useChainId();

  return useQuery({
    queryKey: ['averageLockTime', chainId],
    queryFn: async () => {
      const data = (await querySubgraph({
        url: getChainConstant(SubgraphUrl, chainId),
        query: `{
          epoches(orderDirection:desc orderBy: id first:1) {
            id
          }
          voteLocks(first:1000 where: {active: true}) {
            lockEnd
          }
        } `,
      })) as {
        epoches: { id: string }[];
        voteLocks: { lockEnd: string }[];
      };

      const locks = data.voteLocks.reduce(
        (acc, cur) =>
          acc +
          (Number(cur.lockEnd) > Number(data.epoches[0].id)
            ? Number(cur.lockEnd) - Number(data.epoches[0].id)
            : 0),
        0,
      );

      return locks / data.voteLocks.length;
    },
  });
};

export default useAverageLockTime;
